import { Component, ViewChild, OnInit, HostListener } from '@angular/core';

/*Models */
import { ObservableObject } from '@models/observable-object';

/*Services */
import { ObservableObjectsService } from '@services/http/observable-objects.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { ObjectsService } from '@services/http/objects.service';
import { AppService } from '@services';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'add-object-menu',
  templateUrl: './add-object-menu.component.html'
})

export class AddObjectMenuComponent implements OnInit {
  @ViewChild('addObjectModal') addObjectModal;
  supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  observableObjects: ObservableObject[];
  isFirstInit = true;
  isOpenMenu = false;

  @HostListener('document:touchstart', ['$event']) onClick(btn) {
    if (this.supportsTouch && this.isOpenMenu) {
      if (!btn.target.closest('.add-object-menu')) {
        this.isOpenMenu = false;
      }

    }
  }

  constructor(
    private cachedDataService: CachedDataService,
    private observableObjectsService: ObservableObjectsService,
    private objectsService: ObjectsService,
    private appService: AppService) {
    objectsService.updateObjects.subscribe(() => {
      this.getObject();
    });
  }

  getObject() {
    this.observableObjectsService.getAll().subscribe(response => {
      this.observableObjects =this.appService.filterObjects(response);
      if (!this.observableObjects.length) {
        if (this.isFirstInit) {
          this.addObjectModal.openForm('Car');
          this.isFirstInit = false;
        }
      } else {
        this.cachedDataService.setObservableObjects(this.observableObjects);
      }
    }, error => console.log('from component error', error));
  }
  ngOnInit() {
    this.getObject();

    if (this.supportsTouch) {
      $('.custom-tooltip.icon-object').addClass('show-tooltip');
    }
  }

  get isMobile() {
    let check = false;
    navigator.maxTouchPoints ? check = true : check = false;
    return check;
  }
  showObjectAdd(type: string) {

    this.addObjectModal.openForm(type);
  }
  showDeviceAdd() {
    if (!this.observableObjects.length) {
      this.addObjectModal.openForm('Car');
    } else {
      this.addObjectModal.openDevice();
    }

  }
  openAddMenu(value?) {
    if (this.supportsTouch) {
      if (!value) {
        this.isOpenMenu = !this.isOpenMenu;
      }

    } else {
      if (value) {
        this.isOpenMenu = value;
      } else {
        this.isOpenMenu = !this.isOpenMenu;
      }
    }

  }
}





// WEBPACK FOOTER //
// ./src/app/view/components/add-object-menu/add-object-menu.component.ts